import { render, staticRenderFns } from "./ObservabilityTax.vue?vue&type=template&id=46284752&scoped=true"
import script from "./ObservabilityTax.vue?vue&type=script&lang=js"
export * from "./ObservabilityTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46284752",
  null
  
)

export default component.exports